import { isNil } from "lodash";

type FieldChanges = {
  oldValue: unknown;
  newValue: unknown;
};

type AuditEventWithNestedChanges = {
  event?: {
    changes?: unknown;
  } | null;
};

const getFieldChange = (changes: unknown, field: "value" | "effectiveValue"): FieldChanges | undefined => {
  if (isNil(changes)) {
    return undefined;
  }

  if (Array.isArray(changes)) {
    return changes.find((change): change is FieldChanges => {
      return typeof change === "object" && change !== null && "field" in change && change.field === field;
    });
  }

  if (typeof changes !== "object") {
    return undefined;
  }

  return (changes as Record<string, FieldChanges | undefined>)[field];
};

export const isDataPointEventChangeNonValueUpdate = (event: AuditEventWithNestedChanges): boolean => {
  const effectiveValue = getFieldChange(event.event?.changes, "effectiveValue");
  const value = getFieldChange(event.event?.changes, "value");
  return isNil(value) && isNil(effectiveValue);
};
